module.exports = __webpack_public_path__ + "static/logo-local-0ebcca088b5545400c47aa6a5e1b262d.png";